(() => {
  function init(root=document) {
    root.querySelectorAll('[data-home-buy]').forEach(buy=>{
      if(buy.dataset.homeReady)return;
      const dataNode=buy.querySelector('[data-home-product]');
      if(!dataNode)return;
      const data=JSON.parse(dataNode.textContent);
      let selected=data.variants.find(v=>v.id===data.initial);
      const select=buy.querySelector('[data-home-variant]');
      const buttons=[...buy.querySelectorAll('[data-home-option]')];
      const matching=options=>data.variants.find(v=>v.options.every((value,i)=>value===options[i]));
      function sync(changeImage=false){
        if(!selected)return;
        select.value=selected.id;
        const count=parseInt(selected.options.find(v=>/pillowcase/i.test(v))||'1',10);
        const color=selected.options.find(v=>Object.hasOwn(data.images,v));
        const salePrice=data.salePrices?.[selected.id]??selected.price;
        const baseline=data.compare[selected.id]?.amount||selected.price,save=baseline>0?Math.max(0,Math.round((baseline-salePrice)/baseline*100)):0;
        buy.querySelector('[data-home-price]').textContent=data.prices[selected.id];
        const compare=buy.querySelector('[data-home-compare]'),badge=buy.querySelector('[data-home-save]');
        compare.textContent=data.compare[selected.id]?.label||'';compare.hidden=save<=0;badge.textContent=`SAVE ${save}%`;badge.hidden=save<=0;
        buy.querySelector('[data-home-add]').disabled=!selected.available;
        buy.querySelector('[data-home-add-price]').textContent=selected.available?`— ${data.prices[selected.id]}`:'— Sold out';
        buttons.forEach(button=>{
          const i=Number(button.dataset.homeOption),value=button.dataset.homeValue;
          button.setAttribute('aria-pressed',String(selected.options[i]===value));
          const next=[...selected.options];next[i]=value;
          const candidate=matching(next);
          button.disabled=!candidate?.available;
          const optionPrice=button.querySelector('[data-home-option-price]');
          if(optionPrice&&candidate)optionPrice.textContent=data.prices[candidate.id];
        });
        if(color && changeImage){const image=buy.querySelector('[data-home-product-image]');image.src=data.images[color];image.alt=`The Glide Pillowcase — ${color}`;}
      }
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const next=[...selected.options];next[Number(button.dataset.homeOption)]=button.dataset.homeValue;
        const variant=matching(next);if(variant?.available){selected=variant;sync(true);}
      }));
      select.addEventListener('change',()=>{selected=data.variants.find(v=>String(v.id)===select.value);sync(true);});
      sync();select.hidden=true;buy.querySelector('.home-enhanced-options').hidden=false;buy.dataset.homeReady='true';
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
